import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

type Props = { API: string; onChange?: () => void };
const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const inp: any = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
const lab: any = { fontSize: 12, color: '#374151', marginBottom: 4, display: 'block', fontWeight: 600 };
const btn: any = { padding: '7px 14px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 13, cursor: 'pointer' };
const btnP: any = { ...btn, border: '1px solid #1d4ed8', background: '#1d4ed8', color: '#fff', fontWeight: 600 };
const DEF_OPT = { dpi: '', bw: false, duplex: '', paper: '', copies: '1' };
const optIn = (o: any) => ({ dpi: String((o && o.dpi) || ''), bw: !!(o && o.color === false), duplex: String((o && o.duplex) || ''), paper: String((o && o.paper) || ''), copies: String((o && o.copies) || 1) });
const optOut = (o: any) => ({ dpi: o.dpi || '', color: !o.bw, duplex: o.duplex || '', paper: o.paper || '', copies: parseInt(o.copies, 10) || 1 });
const errOf = (e: any, d: string) => (e && e.response && e.response.data && e.response.data.detail) || d;

export default function PrintNodeSettings({ API, onChange }: Props) {
  const [st, setSt] = useState<any>(null);
  const [key, setKey] = useState('');
  const [printers, setPrinters] = useState<any[]>([]);
  const [sel, setSel] = useState<any>({ label: '', invoice: '' });
  const [opt, setOpt] = useState<any>({ label: { ...DEF_OPT }, invoice: { ...DEF_OPT } });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [test, setTest] = useState<any>(null);
  const [plLoading, setPlLoading] = useState(false);
  const [pMsg, setPMsg] = useState<any>(null);

  const loadPrinters = () => {
    setPlLoading(true);
    axios.get(API + '/settings/printnode/printers', { headers: auth() })
      .then((r: any) => setPrinters((r.data && r.data.printers) || []))
      .catch((e: any) => setErr(errOf(e, 'Nie udało się pobrać listy drukarek.')))
      .finally(() => setPlLoading(false));
  };
  const load = () => {
    axios.get(API + '/settings/printnode', { headers: auth() })
      .then((r: any) => {
        setSt(r.data);
        setSel({ label: r.data.label_printer_id || '', invoice: r.data.invoice_printer_id || '' });
        setOpt({ label: optIn(r.data.label_options), invoice: optIn(r.data.invoice_options) });
        if (r.data.configured) loadPrinters();
      })
      .catch(() => setSt(null));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [API]);

  const pname = (id: string) => {
    const p = printers.find((x: any) => x.id === id);
    return p ? (p.name + (p.computer ? ' (' + p.computer + ')' : '')) : '';
  };

  const saveKey = () => {
    setBusy(true); setMsg(''); setErr(''); setTest(null);
    axios.post(API + '/settings/printnode', { api_key: key }, { headers: auth() })
      .then((r: any) => { setSt(r.data); setKey(''); setMsg('Zapisano klucz API - PrintNode przyjął klucz.'); loadPrinters(); if (onChange) onChange(); })
      .catch((e: any) => setErr(errOf(e, 'Nie udało się zapisać klucza.')))
      .finally(() => setBusy(false));
  };
  const savePrinters = () => {
    setBusy(true); setMsg(''); setErr(''); setPMsg({ ok: null, text: '⏳ Zapisywanie…' });
    axios.post(API + '/settings/printnode', {
      label_printer_id: sel.label, label_printer_name: pname(sel.label),
      invoice_printer_id: sel.invoice, invoice_printer_name: pname(sel.invoice),
      label_options: optOut(opt.label), invoice_options: optOut(opt.invoice),
    }, { headers: auth() })
      .then((r: any) => { setSt(r.data); setOpt({ label: optIn(r.data.label_options), invoice: optIn(r.data.invoice_options) }); setPMsg({ ok: true, text: '✓ Zapisano drukarki i ustawienia wydruku (' + new Date().toLocaleTimeString('pl-PL') + ').' }); if (onChange) onChange(); })
      .catch((e: any) => setPMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zapisać drukarek.') }))
      .finally(() => setBusy(false));
  };
  const runTest = () => {
    setBusy(true); setTest(null); setMsg(''); setErr('');
    axios.post(API + '/settings/printnode/test', {}, { headers: auth() })
      .then((r: any) => setTest(r.data))
      .catch((e: any) => setTest({ ok: false, message: errOf(e, 'Test nieudany.') }))
      .finally(() => setBusy(false));
  };
  const remove = () => {
    if (!window.confirm('Usunąć klucz API i ustawienia PrintNode?')) return;
    axios.delete(API + '/settings/printnode', { headers: auth() })
      .then(() => { setMsg('Usunięto ustawienia PrintNode.'); setTest(null); setPrinters([]); load(); if (onChange) onChange(); })
      .catch((e: any) => setErr(errOf(e, 'Nie udało się usunąć ustawień.')));
  };

  const box = (ok: boolean, text: string) => (
    <div style={{ background: ok ? '#f0fdf4' : '#fef2f2', border: '1px solid ' + (ok ? '#bbf7d0' : '#fecdd3'), color: ok ? '#15803d' : '#b91c1c', borderRadius: 8, padding: '8px 12px', fontSize: 13, marginBottom: 10 }}>{text}</div>
  );
  const setO = (t: string, k: string, v: any) => setOpt((p: any) => ({ ...p, [t]: { ...p[t], [k]: v } }));
  const small: any = { ...inp, padding: '5px 8px', fontSize: 12 };
  const note: any = { fontSize: 12, color: '#6b7280', paddingTop: 4, lineHeight: 1.3 };
  const slab: any = { fontSize: 11, color: '#6b7280', marginBottom: 3, display: 'block' };
  const withSaved = (list: string[], v: string) => (v && list.indexOf(v) < 0 ? [v].concat(list) : list);
  const optionsBox = (t: string) => {
    const p = printers.find((x: any) => x.id === sel[t]);
    const caps = (p && p.caps) || {};
    const o = opt[t];
    const dpis: string[] = withSaved(Array.isArray(caps.dpis) ? caps.dpis : [], o.dpi);
    const papers: string[] = withSaved(Array.isArray(caps.papers) ? caps.papers : [], o.paper);
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 8, marginTop: 8, padding: 10, background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8 }}>
        <div><label style={slab}>Jakość druku (DPI)</label>
          {dpis.length > 1 ? (
            <select value={o.dpi} onChange={(e: any) => setO(t, 'dpi', e.target.value)} style={small}>
              <option value="">domyślna drukarki</option>
              {dpis.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          ) : <div style={note}>{dpis.length === 1 ? 'drukarka ma tylko ' + dpis[0] + ' — brak wyboru' : 'sterownik drukarki nie podaje rozdzielczości — drukuje w swojej domyślnej'}</div>}
        </div>
        <div><label style={slab}>Kolor</label>
          {caps.color === false
            ? <div style={note}>drukarka czarno-biała</div>
            : (
              <select value={o.bw ? 'bw' : 'color'} onChange={(e: any) => setO(t, 'bw', e.target.value === 'bw')} style={small}>
                <option value="color">kolorowy</option>
                <option value="bw">czarno-biały</option>
              </select>
            )}
        </div>
        <div><label style={slab}>Druk</label>
          {caps.duplex || o.duplex ? (
            <select value={o.duplex} onChange={(e: any) => setO(t, 'duplex', e.target.value)} style={small}>
              <option value="">jednostronny (ustawienie drukarki)</option>
              <option value="long-edge">dwustronny — dłuższa krawędź</option>
              <option value="short-edge">dwustronny — krótsza krawędź</option>
            </select>
          ) : <div style={note}>tylko jednostronny — drukarka nie obsługuje druku dwustronnego</div>}
        </div>
        {papers.length ? (
          <div><label style={slab}>Papier</label>
            <select value={o.paper} onChange={(e: any) => setO(t, 'paper', e.target.value)} style={small}>
              <option value="">domyślny drukarki</option>
              {papers.map((x) => <option key={x} value={x}>{x}</option>)}
            </select></div>
        ) : null}
        <div><label style={slab}>Liczba kopii</label>
          <input type="number" min={1} max={20} value={o.copies} onChange={(e: any) => setO(t, 'copies', e.target.value)} style={small} /></div>
      </div>
    );
  };
  const printerSelect = (t: string, label: string) => (
    <div style={{ marginBottom: 14 }}>
      <label style={lab}>{label}</label>
      <select value={sel[t]} onChange={(e: any) => { const v = e.target.value; setSel((p: any) => ({ ...p, [t]: v })); }} style={inp}>
        <option value="">— nie wybrano —</option>
        {sel[t] && !printers.some((p: any) => p.id === sel[t])
          ? <option value={sel[t]}>{(st && st[t + '_printer_name']) || ('drukarka ' + sel[t])} (brak na liście)</option> : null}
        {printers.map((p: any) => (
          <option key={p.id} value={p.id}>
            {p.name}{p.computer ? ' — ' + p.computer : ''}{p.state && p.state !== 'online' ? ' [' + p.state + ']' : ''}{p.computer_state && p.computer_state !== 'connected' ? ' [komputer: ' + p.computer_state + ']' : ''}
          </option>
        ))}
      </select>
      {sel[t] ? optionsBox(t) : null}
    </div>
  );

  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, maxWidth: 640 }}>
      <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 6 }}>PrintNode</div>
      <div style={{ fontSize: 13, color: '#374151', marginBottom: 12 }}>
        Ponowny wydruk etykiet i faktur z zamówienia na drukarce podłączonej przez PrintNode. Załóż konto na printnode.com,
        zainstaluj klienta PrintNode na komputerze z drukarką i wklej tutaj klucz API (PrintNode → Account → API).
      </div>
      {err ? box(false, err) : null}
      {msg ? box(true, msg) : null}
      {test ? box(!!test.ok, (test.ok ? '✓ ' : '✕ ') + String(test.message || '')) : null}

      <label style={lab}>Klucz API {st && st.configured ? <span style={{ fontWeight: 400, color: '#15803d' }}>(zapisany — wpisz nowy, aby zmienić)</span> : null}</label>
      <input type="password" value={key} onChange={(e: any) => setKey(e.target.value)} autoComplete="new-password" placeholder={st && st.configured ? '••••••••' : 'klucz API z PrintNode'} style={{ ...inp, marginBottom: 10 }} />
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
        <button onClick={saveKey} disabled={busy || !key.trim()} style={{ ...btnP, opacity: busy || !key.trim() ? 0.5 : 1 }}>Zapisz klucz</button>
        <button onClick={runTest} disabled={busy || !(st && st.configured)} style={{ ...btn, opacity: busy || !(st && st.configured) ? 0.5 : 1 }}>Testuj połączenie</button>
        {st && st.configured ? <button onClick={remove} style={{ ...btn, color: '#b91c1c', borderColor: '#fecdd3' }}>Usuń</button> : null}
      </div>

      {st && st.configured ? (
        <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <div style={{ fontWeight: 600, fontSize: 13, flex: 1 }}>Domyślne drukarki</div>
            <button onClick={loadPrinters} disabled={plLoading} style={{ ...btn, padding: '3px 10px', fontSize: 12 }}>{plLoading ? '⏳' : '↻ Odśwież listę'}</button>
          </div>
          {!plLoading && printers.length === 0 ? <div style={{ fontSize: 12, color: '#b45309', marginBottom: 8 }}>Brak drukarek na koncie PrintNode — uruchom klienta PrintNode na komputerze z drukarką.</div> : null}
          {printerSelect('label', 'Drukarka etykiet')}
          {printerSelect('invoice', 'Drukarka faktur')}
          <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 8 }}>Listy wyboru pokazują to, co sterownik drukarki zgłasza do PrintNode. Czy drukarka zastosuje ustawienie (np. czarno-biały), zależy od jej sterownika.</div>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <button onClick={savePrinters} disabled={busy} style={{ ...btnP, opacity: busy ? 0.5 : 1 }}>Zapisz drukarki i ustawienia</button>
            {pMsg ? <span style={{ fontSize: 13, fontWeight: 600, color: pMsg.ok === true ? '#15803d' : (pMsg.ok === false ? '#b91c1c' : '#6b7280') }}>{pMsg.text}</span> : null}
          </div>
        </div>
      ) : null}
    </div>
  );
}
